<template>
	<div class="contact">
		<navbar></navbar>
		<!-- 主要内容区 -->
		<div class="container mx-auto px-4 py-8">
			<div class="bg-white rounded-lg shadow-sm p-6">
				<div class="flex space-x-8">
					<!-- 左侧图片预览 -->
					<div class="w-2/5 flex gap-4">
						<div class="grid gap-2 leftScroll p-1" style="grid-auto-rows: min-content">
							<div
								v-for="(img, index) in pics"
								:key="index"
								@mouseover="mainPic = img"
								class="w-20 h-20 rounded-md overflow-hidden cursor-pointer googBox_red"
							>
								<img :src="img" class="w-full h-full object-cover" :alt="`预览图 ${index + 1}`" />
							</div>
						</div>
						<div class="flex-1 aspect-w-1 aspect-h-1 bg-gray-100 rounded-lg overflow-hidden main-img">
							<img :src="mainPic" class="w-full h-full object-cover" alt="商品图片" />
						</div>
					</div>
					<!-- 右侧商品信息 -->
					<div class="flex-1">
						<h1 class="text-3xl font-medium mb-4">
							{{ productName }}
						</h1>

						<!-- 规格选择 -->
						<div class="space-y-6">
							<div class="flex justify-start" v-for="(item, index) in showKeysV2" :key="index">
								<div class="text-gray-700 text-title">{{ item.name }}</div>
								<div class="flex space-x-4" style="flex-wrap: wrap">
									<el-button
										v-for="(item2, idx) in item.item"
										:key="idx"
										:disabled="item2.disabled"
										:data-index="idx"
										@click="selectSkuEvent(index, idx, item2.name)"
										:class="[
											'px-6 py-2 border !rounded-button whitespace-nowrap mb-1',
											item2.actived ? 'btn-active' : item2.disabled ? '' : 'border-gray-300',
										]"
									>
										{{ item2.name }}{{ item2.tab }}
									</el-button>
								</div>
							</div>
						</div>
						<el-divider></el-divider>
						<div class="border-top p-4 rounded-lg mb-6 flex justify-end">
							<div class="text-4xl font-semibold mr-4" style="color: #ff2e00">
								<span class="text-2xl">¥</span>{{ dayPrice }}<span class="text-2xl">/天</span>
							</div>
							<el-button class="float-right btn-NoDeposit" @click="showQRCodeModal = true"
								>立享免押</el-button
							>
						</div>
					</div>
				</div>
				<!-- 商品详情 -->
				<div class="mt-12">
					<div class="border-b">
						<div class="flex space-x-8 text-xl">
							<div
								v-for="tab in tabs"
								:key="tab"
								:class="[
									'px-8 py-4 font-medium whitespace-nowrap',
									currentTab === tab ? 'text-green-d border-b-2 border-blue-600' : 'text-gray-d',
								]"
								@click="currentTab = tab"
							>
								{{ tab }}
							</div>
						</div>
					</div>
					<div class="flex">
						<div class="py-8">
							<div v-if="currentTab === '商品详情'" class="space-y-6 flex-1" style="min-width: 55rem">
								<div v-html="productDetail"></div>
							</div>
							<div v-if="currentTab === '租赁流程'" class="space-y-6 flex-1" style="min-width: 55rem">
								<img src="https://dalongfa.oss-cn-shenzhen.aliyuncs.com/applet/zllc.png" alt="" />
							</div>
							<div v-if="currentTab === '常见问题'" class="space-y-6 flex-1" style="min-width: 55rem">
								<div style="background: #fff" v-if="currentTab == '常见问题'">
									<div class="border-b" style="margin-bottom: 20px">
										<div class="flex space-x-8 justify-center">
											<div
												v-for="tab in tabs2"
												:key="tab.key"
												:class="[
													'px-8 py-4 font-medium whitespace-nowrap',
													currentTab2 === tab.key
														? 'text-green-d border-b-2 border-blue-600'
														: 'text-gray-d',
												]"
												@click="currentTab2 = tab.key"
											>
												{{ tab.name }}
											</div>
										</div>
									</div>
									<Collapse :tab="currentTab2"></Collapse>
								</div>
							</div>
						</div>
						<div style="width: 55rem">
							<div class="rentD-box p-4 m-4">
								<div class="flex justify-start items-center mb-6">
									<img :src="mainPic" alt="" class="w-20 h-20 rounded-md overflow-hidden mr-4" />
									<div class="text-4xl font-semibold" style="color: #ff2e00">
										<span class="text-2xl">¥</span>{{ dayPrice }}<span class="text-2xl">/天</span>
									</div>
								</div>
								<div class="space-y-6">
									<div class="flex justify-start" v-for="(item, index) in showKeysV2" :key="index">
										<div class="text-gray-700 text-title">{{ item.name }}</div>
										<div class="flex-1 space-x-4" style="flex-wrap: wrap">
											<el-button
												v-for="(item2, idx) in item.item"
												:key="idx"
												:disabled="item2.disabled"
												:data-index="idx"
												@click="selectSkuEvent(index, idx, item2.name)"
												:class="[
													'px-6 py-2 border !rounded-button whitespace-nowrap mb-1',
													item2.actived
														? 'btn-active'
														: item2.disabled
															? ''
															: 'border-gray-300',
												]"
											>
												{{ item2.name }}{{ item2.tab }}
											</el-button>
										</div>
									</div>
								</div>
								<el-divider></el-divider>
								<div class="border-top p-4 rounded-lg mb-6 flex justify-center">
									<el-button class="float-right btn-NoDeposit" @click="showQRCodeModal = true"
										>立享免押</el-button
									>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 二维码弹出框 -->
		<el-dialog
			title="使用支付宝扫描二维码立享免押租赁"
			:visible.sync="showQRCodeModal"
			width="30%"
			:show-close="false"
			center
		>
			<div class="flex justify-center">
				<img :src="qrCodeUrl" alt="二维码" />
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="showQRCodeModal = false">关闭</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import QRCode from 'qrcode';
const skuUtil = require('@/util/sku.js');
const disUtil = require('@/util/discount.js');
import Collapse from '@/components/Collapse/Collapse.vue';
import { productsDetail } from '@/api/index';
export default {
	components: { Collapse },
	data() {
		return {
			dayPrice: '0.00',
			quantity: 1,
			currentTab: '商品详情',
			currentTab2: 1,
			tabs: ['商品详情', '租赁流程', '常见问题'],
			tabs2: [
				{
					key: 1,
					name: '订单问题',
				},
				{
					key: 2,
					name: '支付问题',
				},
				{
					key: 3,
					name: '发货问题',
				},
				{
					key: 4,
					name: '售后问题',
				},
			],
			productName: '',
			oper: 'rent',
			pics: [],
			detail: {},
			qualityFlag: null,
			adv: null,
			hasSale: null,
			insurance: {
				show: false,
				name: '',
				desc: '',
				money: 0,
				checked: false,
				id: 0,
			},
			mainPic: '',
			productDetail: '',
			showKeysV2: [],
			resultSkuV2: {},
			TabList: [],
			sku: {},
			discount: {},
			qrCodeUrl: '',
			showQRCodeModal: false,
		};
	},
	created() {},
	destroyed() {},
	mounted() {
		this.id = window.sessionStorage.getItem('id');
		window.sessionStorage.setItem('BlankData', null);

		this.IndividualRentDetail();
		this.generateQRCode();
	},
	methods: {
		//初始化二维码
		generateQRCode() {
			const url = `alipays://platformapi/startapp?appId=2021003131606511&page=pages/product/detail/detail?id=${this.id}&ss=1f3eba97-c478-4d03-a683-4e502337ac1c`; // 替换为你的配置地址
			QRCode.toDataURL(url, (err, url) => {
				if (err) {
					console.error(err);
				} else {
					this.qrCodeUrl = url;
				}
			});
		},
		tabclick2(e) {
			this.currentTab2 = e;
		},
		initPage(data) {
			if (data.skus && data.skus.length > 0) {
				if (data.skus[data.skus.length - 1].attributesJson) {
					for (let i = 0; i < data.skus[data.skus.length - 1].attributesJson.length; i++) {
						data.skus[data.skus.length - 1].attributesJson[i].value =
							data.skus[data.skus.length - 1].attributesJson[i].value.trim();
					}
				}
			}
			this.productName = data.name;
			this.pics = data.pics;
			this.mainPic = data.mainPic;
			this.detail = data;
			var defSku = this.findMinMoneySku(data);
			var minDeposit = defSku.deposit;
			var skuKeysV2 = skuUtil.build(data.skus, data.rentDay ? 'day' : 'month');

			var retValue = skuUtil.checkSku(skuKeysV2.keys, skuKeysV2.sku);
			data.minDeposit = minDeposit;
			for (var i = 0; i < retValue.keys.length; i++) {
				var retkey = retValue.keys[i];
				if (retkey.name == '租赁时长') {
					var items = retkey.item;
					retkey.item = this.dayPop(items);
					break;
				}
			}

			//默认选中最低租赁价格
			retValue.keys.map(item => {
				defSku.skuList.forEach(key => {
					if (key.key == item.name) {
						item.item = item.item.map(ele => {
							if (ele.name == key.value) {
								ele.actived = ele.disabled ? false : true;
							}
							return ele;
						});
					}
				});
				return item;
			});
			this.showKeysV2 = retValue.keys;
			this.resultSkuV2 = skuKeysV2.sku;
			console.log(this.showKeysV2, this.resultSkuV2);
			this.defaultSelectSku();
		},
		selectSkuEvent(index, idx, name) {
			console.log(index, idx, name, 444);
			this.selectedSize = name;
			var skuIndex = index;
			var index = idx;
			var keys = this.showKeysV2;
			var row = keys[skuIndex].item[index];
			console.log(row, 555);
			if (row.disabled) {
				return;
			}
			var attrVal = !row.actived;
			if (attrVal) {
				keys[skuIndex].item.forEach(k => {
					k.actived = false;
				});
			}
			keys[skuIndex].item[index].actived = attrVal;
			var retValue = skuUtil.checkSku(keys, this.resultSkuV2);
			this.showKeysV2 = retValue.keys;

			this.defaultSelectSku();
		},

		defaultSelectSku() {
			var sku = skuUtil.getSelectSku(this.showKeysV2, this.resultSkuV2, this.oper);
			var timeLen = this.$isNotBlank(sku) ? skuUtil.getSelectTimeLen(sku) : 0;
			if (this.$isNotBlank(sku) && timeLen > 0) {
				this.dayPrice = (Number(sku.totalRentPrice) / timeLen).toFixed(2);
			}
		},
		productMinMoney(product, sku) {
			if (product.rentDay) {
				return sku.salePriceDay;
			}
			if (product.rentMonth) {
				return sku.totalRentPrice;
			}
		},
		dayPop(arr) {
			var tem;
			for (var i = 0; i < arr.length - 1; i++) {
				//确定轮数
				for (var j = 0; j < arr.length - i - 1; j++) {
					//确定每次比较的次数
					var item = arr[j];
					var next_item = arr[j + 1];
					if (parseInt(item.name) > parseInt(next_item.name)) {
						tem = item;
						arr[j] = next_item;
						arr[j + 1] = tem;
					}
				}
			}
			return arr;
		},
		findMinMoneySku(product) {
			console.log(product, 1124);
			var that = this;
			// var skus = product.skus.map(item => {
			// 	var money = that.productMinMoney(product, item);
			// 	return { m: money, sku: item };
			// }).sort((a, b) => { return a.m >= b.m ? 1 : -1; });
			// return skus[0].sku;
			var skus = product.skus.map(item => {
				var money = that.productMinMoney(product, item);
				return { m: money, sku: item };
			});
			return skus[skus.length - 1].sku;
		},
		IndividualRentDetail() {
			productsDetail({
				id: this.id,
			}).then(res => {
				console.log(res.data.detail);
				// this.productData = res.data;
				this.productDetail = res.data.detail;
				this.initPage(res.data);
			});
		},
	},
};
</script>

<style lang="scss" scoped>
.product-detail {
	background-color: #ffffff;
}
.spec-item {
	border-radius: 8px;
	transition: all 0.3s ease;
}
.spec-item:hover {
	transform: translateY(-2px);
	box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}
input[type='number']::-webkit-inner-spin-button,
input[type='number']::-webkit-outer-spin-button {
	-webkit-appearance: none;
	margin: 0;
}
.border-gray-300 {
	&:hover {
		background: none;
		border: 1px solid #00733d;
		color: #00733d;
	}
	&:visited {
		background: none;
		border: 1px solid #00733d;
		color: #00733d;
	}
}
.btn-active {
	background: none;
	border: 1px solid #00733d;
	color: #00733d;
	&:hover {
		border: 1px solid #00733d;
		color: #00733d;
	}
}
.btn-NoDeposit {
	background: #00733d;
	border-radius: 5px 5px 5px 5px;
	color: #ffffff;
	font-size: 22px;
	width: 9.18rem;
	height: 3rem;
	&:active {
		background: #038a4b;
		color: #ffffff;
	}
	&:hover {
		background: #038a4b;
		color: #ffffff;
	}
}
.text-title {
	width: 5rem;
}
.main-img {
	width: 33.43rem;
}
.text-green-d {
	color: #00733d;
	border-bottom: #00733d 2px solid;
}
.text-gray-d {
	&:hover {
		border-bottom: #00733d 2px solid;
		color: #00733d;
	}
}

.swiper-tab {
	width: 100%;
	text-align: center;
	display: flex;
	font-size: 28rpx;
}
.swiper-tab-item {
	flex: 1;
	color: #333333;
	position: relative;
	padding: 25rpx 0;
}

.swiper-tab-item-active {
	width: 40rpx;
	height: 8rpx;
	background: #f25a34;
	position: absolute;
	right: 0;
	left: 0;
	bottom: 0;
	margin: 0 auto;
	border-radius: 8rpx;
}
.leftScroll {
	max-height: 29.68rem;
	overflow-y: scroll;
}
.leftScroll::-webkit-scrollbar {
	width: 0; /* Chrome, Safari, and Opera */
}

.leftScroll::-webkit-scrollbar-track {
	background: transparent; /* Chrome, Safari, and Opera */
}

.leftScroll::-webkit-scrollbar-thumb {
	background: transparent; /* Chrome, Safari, and Opera */
}
.rentD-box {
	background: #ffffff;
	box-shadow: 0rem 0.25rem 0.94rem 0rem rgba(0, 0, 0, 0.05);
	border-radius: 0.94rem 0.94rem 0.94rem 0.94rem;
	border: 0.06rem solid #e4e4e4;
	position: sticky;
	top: 8rem;
}
::v-deep .el-button + .el-button,
.el-checkbox.is-bordered + .el-checkbox.is-bordered {
	margin-left: 0;
	margin-right: 10px;
}
::v-deep .el-button {
	margin-left: 0;
	margin-right: 10px;
}
</style>
